/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SystemSettingDto from './SystemSettingDto';

/**
 * The GetSystemSettingsResponseModel model module.
 * @module model/GetSystemSettingsResponseModel
 * @version v1.0.0
 */
class GetSystemSettingsResponseModel {
    /**
     * Constructs a new <code>GetSystemSettingsResponseModel</code>.
     * @alias module:model/GetSystemSettingsResponseModel
     */
    constructor() { 
        
        GetSystemSettingsResponseModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GetSystemSettingsResponseModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetSystemSettingsResponseModel} obj Optional instance to populate.
     * @return {module:model/GetSystemSettingsResponseModel} The populated <code>GetSystemSettingsResponseModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetSystemSettingsResponseModel();

            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], {'String': SystemSettingDto});
            }
        }
        return obj;
    }


}

/**
 * @member {Object.<String, module:model/SystemSettingDto>} result
 */
GetSystemSettingsResponseModel.prototype['result'] = undefined;






export default GetSystemSettingsResponseModel;

